import { render, staticRenderFns } from "./GeneralInfoForm.vue?vue&type=template&id=3d4e77d6&"
import script from "./GeneralInfoForm.vue?vue&type=script&lang=js&"
export * from "./GeneralInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInfoForm.vue?vue&type=style&index=0&id=3d4e77d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports